import getApi from '../../api'

export const deleteSurvey = (surveyId: number) => getApi().delete<void>(`surveys/${surveyId}`)
